import React                                       from 'react';
import { smallestHoleSize as tooltip }             from 'pu-data/Tooltips';
import SelectComponent                             from 'pu-react/components/SelectComponent';
import { smallestHoleSizeRange as defaultOptions } from '../../data/selectOptions';

const SmallestHoleSizeRange = ({
  options, parameters, onChangeParameter, groupName, className, label,
}) => {
  const name = 'smallest_hole_size_range';
  const onChange = e => onChangeParameter(name, e.target.value);
  const value = parameters.get ? parameters.get(name) : parameters[name];
  return (
    <SelectComponent
      label={label}
      name={name}
      onChange={onChange}
      options={options}
      tooltip={tooltip}
      selected={value}
      groupName={groupName}
      className={className} />
  );
};

SmallestHoleSizeRange.defaultProps = {
  options: defaultOptions,
  label  : 'Smallest<br class="d-none d-lg-block" /> Hole Size',
};

export default SmallestHoleSizeRange;
